export default __webpack_public_path__ + "static/media/Phone.5de69c19.svg";